'use strict';

var React = require('react');

var SvgRecentSearchesMajor = function SvgRecentSearchesMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M9.75 6.5a.75.75 0 0 0-1.5 0v2.5c0 .284.16.544.415.67l1.5.75a.75.75 0 1 0 .67-1.34l-1.085-.544v-2.036Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9 14.5c1.248 0 2.4-.416 3.323-1.117l2.897 2.897a.75.75 0 1 0 1.06-1.06l-2.897-2.897a5.5 5.5 0 1 0-4.383 2.177Zm0-1.5a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z"
  }));
};
SvgRecentSearchesMajor.displayName = "RecentSearchesMajor";

exports.SvgRecentSearchesMajor = SvgRecentSearchesMajor;
